import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

import { IonSkeletonText } from '@ionic/angular/standalone';
import { twMerge } from 'tailwind-merge';

import { type SkeletonRadius } from './skeleton.types';

@Component({
  selector: 'ml-skeleton',
  imports: [IonSkeletonText],
  host: {
    '[attr.data-radius]': 'radius()',
    '[class]': 'hostClass()',
    'aria-hidden': 'true',
  },
  template: '<ion-skeleton-text [animated]="animated()" />',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonComponent {
  readonly animated = input(true, { transform: booleanAttribute });
  readonly radius = input<SkeletonRadius>('sm');
  readonly extraClass = input<string>('', { alias: 'class' });

  protected readonly hostClass = computed(() =>
    twMerge('block overflow-hidden', this.extraClass()),
  );
}
